import {
  BackNextButton, Button, Modal,
} from "../../../../../common";
import { ReactComponent as Info } from "../../../../../../assets/icons/info.svg";
import { ReactComponent as Error } from "../../../../../../assets/icons/error.svg";
import { isDateGreaterThanProvidedYearsAgo } from "../../../../../../utils/Helper";
import { useSelector } from "react-redux";
import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ReactComponent as MoreInfo } from "../../../../../../assets/moreInfo.svg";
import { ReactComponent as Spinner } from "../../../../../../assets/icons/spinner.svg";
import { ReactComponent as ReUploadIcon } from "../../../../../../assets/images/companyIcons/ReUploadIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../../../../assets/images/companyIcons/delete.svg";
import pdf1 from "../../../../../../assets/images/pdf.svg";
import { uploadFileToS3 } from "../../../../../../utils/uploadFileToS3";
import { uploadFilePath } from "../../../../../../constants/s3UploadPath";
import { useUploadFinanceDocumentsMutation, useGetDocumentToFillDataMutation, } from "../../../../../../store/Company/companyApiSlice";
import { CommonToast } from "../../../../../common/Toast";

export const UploadDocuments = ({ onPrev, onNext, onSkip }) => {
  const { token, userInfo } = useSelector((state) => state.auth);
  const [uploadFinanceDocuments, { isLoading: uploadingData }] = useUploadFinanceDocumentsMutation();
  const [getDocumentToFillData, { isLoading: documentGeting }] = useGetDocumentToFillDataMutation();

  const { id } = useParams();
  const fileInputRef = useRef([]);
  const [optionDisplay, setOptionDisplay] = useState(Array(5).fill(false));
  const [isDragging, setIsDragging] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(Array(6).fill(null));
  const [isDataLoading, setIsDataLoading] = useState(false)
  const [currentLoadingIndex, setCurrentLoadingindex] = useState(-1);
  const [imageArray, setImageArray] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const currentYear = new Date().getFullYear();
  const [error, setError] = useState({ message: '' });
  const [missedYear, setMissedYear] = useState([]);
  const [years, setYears] = useState([]);
  const [getDocumentRan, setGetDocumentRan] = useState(false);
  const yearsArray = Array.from({ length: 6 }, (_, index) => {
    const year = currentYear - index;
    return {
      name: `Year ${year}`,
      update: `Year ${year}`,
      year: year,
      error: false
    };
  });

  const getImagesData = async (yearsArray) => {
    if (!getDocumentRan) {
      const imagesDataRequest = await getDocumentToFillData({
        token: token,
        companyId: currentEditingCompany?.companyID
      });
      const createdImageArray = []
      for (const data of imagesDataRequest?.data?.data) {
        const year = parseInt(data.yearID.split('-')[0]); // Extract the year from yearID
        const index = yearsArray.findIndex(item => item.year === year); // Find the index of the year in years array
        if (index !== -1) {
          previewUrl[index] = data.document;
          createdImageArray.push({ year: year, document: data?.document })
        }
      }
      if (imageArray.length === 0) {
        setImageArray(createdImageArray)
      }
      setGetDocumentRan(true)
    }
  };

  useEffect(() => {
    const updatedYears = yearsArray.map(yearObj => {
      const { year } = yearObj;
      return {
        ...yearObj,
        error: missedYear.includes(year)
      };
    });
    setYears(updatedYears);
    getImagesData(updatedYears);
  }, [missedYear])

  const { currentEditingCompany } = useSelector((state) => state.company);

  const handlePrev = () => {
    onPrev();
  }
  const result = currentEditingCompany?.date_of_establishment ? isDateGreaterThanProvidedYearsAgo(currentEditingCompany?.date_of_establishment, 3) : false;
  const checkYearValidity = (dataArray) => {
    const currentYear = new Date().getFullYear();
    const validYears = Array.from({ length: 5 }, (_, i) => currentYear - i);
    const hasCurrentYear = dataArray.some((item) => item.year === currentYear);
    let isInvalidData = false;
    if (hasCurrentYear) {
      const hasInvalidData = dataArray?.some((item) => !validYears.includes(item.year));
      isInvalidData = hasInvalidData;
    }

    let errorMessage = "";

    if (hasCurrentYear) {
      // Include values of the previous 2 years
      const previousYears = [currentYear - 1, currentYear - 2];
      const missingYears = previousYears.filter((year) => !dataArray.some((item) => (item.year === year && item?.document !== "")));
      setMissedYear(missingYears);
      if (missingYears.length > 0) {
        errorMessage = `Please add data for ${missingYears.join(" and ")}.`;
      }
    } else {
      // Include values of the current year - 1 and its consecutive last two years
      const previousYears = [currentYear - 1, currentYear - 2, currentYear - 3];
      const missingYears = previousYears.filter((year) => !dataArray.some((item) => item.year === year && item?.document !== ""));
      setMissedYear(missingYears);
      if (missingYears.length > 0) {
        errorMessage = `Data for ${missingYears.join(" and ")} is required.`;
      }
    }

    return {
      warning: isInvalidData,
      validData: dataArray,
      errorMessage: errorMessage,
    };
  };

  const handleSubmit = async (e, upload = true, accept = false) => {
    try {
      if (e !== '') {
        e?.preventDefault();
      }
      const validity = checkYearValidity(imageArray);
      if (validity?.errorMessage) {
        setError({ message: validity?.errorMessage });
        document.getElementById('view')?.scrollIntoView({ behavior: 'smooth' });
      } else if (validity?.warning && !accept) {
        setError({ message: validity?.errorMessage });
        setIsOpen(true)
      } else if (upload) {
        let payloadArray = imageArray;
        if (accept) {
          const thresholdYear = currentYear - 5;
          const filteredData = imageArray.filter(entry => entry.year > thresholdYear);
          payloadArray = filteredData;
        }
        const response = await uploadFinanceDocuments({
          data: payloadArray,
          token: token,
          companyId: currentEditingCompany?.companyID
        });
        if (response?.data?.statusCode === 200) {
          CommonToast.success(response?.data?.message);
          onNext(0, "MOA", "Upload KK");
        } else {
          CommonToast.error(response?.error?.data?.messages?.length > 0 ? response?.error?.data?.messages[0]?.message : "Error occured while processing your request");
        }
      } else if (!upload) {
        setError({ message: validity?.errorMessage });
      }
    } catch (error) {
      CommonToast.error(error?.data?.message || error?.message || "Something went wrong");
    }

  };

  useEffect(() => {
    if (error?.message !== '') {
      handleSubmit('', false, false)
    }
  }, [imageArray])

  function get_url_extension(url) {
    if (url !== undefined) {
      return url.split(/[#?]/)[0].split(".").pop().trim();
    }
  }
  const handleFileChange = async (e, index, item) => {
    setCurrentLoadingindex(index);
    setIsDataLoading(true);
    const file = e.target.files[0];
    const nameValue = e.target.parentElement.previousElementSibling.innerText;
    const response = await uploadFileToS3(uploadFilePath?.auditedFinancial, file, token, currentEditingCompany?.companyID);
    const existingIndex = imageArray.findIndex((img) => img.year === item?.year);
    
    // If the year exists, update the document URL; otherwise, add a new entry
    if(response?.url){
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          const updatedPreviewUrls = [...previewUrl];
          if (file.type == "application/pdf") {
            updatedPreviewUrls[index] = pdf1;
          } else {
            updatedPreviewUrls[index] = reader.result;
          }
          setPreviewUrl(updatedPreviewUrls);
        };
        reader.readAsDataURL(file);
      }
      if (existingIndex !== -1) {
        const updatedImageArray = [...imageArray];
        updatedImageArray[existingIndex] = { year: item?.year, document: response?.url };
        setImageArray(updatedImageArray);
  
      } else {
        setImageArray([...imageArray, { year: item?.year, document: response?.url }]);
      }
    }
    setOptionDisplay((prevState) => {
      const updatedOptionDisplay = [...prevState];
      updatedOptionDisplay[index] = !updatedOptionDisplay[index];
      setIsDataLoading(false);
      return updatedOptionDisplay;
    });
    setCurrentLoadingindex(-1);
    setIsDataLoading(false);
  };

  const handleChooseFile = async (index) => {
    const file = fileInputRef.current[index].click();
    setOptionDisplay((prevState) => {
      const updatedOptionDisplay = [...prevState];
      updatedOptionDisplay[index] = !updatedOptionDisplay[index];
      return updatedOptionDisplay;
    });
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    setIsDragging(index);
  };

  const handleDragLeave = (e, index) => {
    setIsDragging(false);
    setOptionDisplay((prevState) => {
      const updatedOptionDisplay = [...prevState];
      updatedOptionDisplay[index] = !updatedOptionDisplay[index];
      return updatedOptionDisplay;
    });
  };

  const handleDrop = async (e, index) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];

    const nameValue = e.target.parentElement.previousElementSibling.innerText;
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const updatedPreviewUrls = [...previewUrl];
        updatedPreviewUrls[index] = reader.result;
        setPreviewUrl(updatedPreviewUrls);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleOption = (index, option) => {
    if (option === "reupload") {
      fileInputRef.current[index].click();
    } else if (!isDataLoading) {
      setOptionDisplay((prevState) => {
        const updatedOptionDisplay = [...prevState];
        updatedOptionDisplay[index] = !updatedOptionDisplay[index];
        return updatedOptionDisplay;
      });
    }
  };
  // const deleteDocument = (index, item) => {
  //   const updatedPreviewUrls = [...previewUrl];
  //   updatedPreviewUrls[index] = null;
  //   setPreviewUrl(updatedPreviewUrls);

  //   // Find the corresponding object in imageArray based on index
  //   const deletedYear = item?.year;

  //   setOptionDisplay((prevState) => {
  //     const updatedOptionDisplay = [...prevState];
  //     updatedOptionDisplay[index] = !updatedOptionDisplay[index];
  //     return updatedOptionDisplay;
  //   });

  //   // Remove the object from imageArray based on the found year
  //   const updatedImageArray = imageArray.filter((item) => item.year !== deletedYear);
  //   setImageArray(updatedImageArray);
  // };

  const viewDoc = (doclink) => {
    window.open(doclink, "_blank");
  };

  const modalHandle = (e) => {
    setIsOpen(!isOpen);
  };
  return (
    <div id="view" className="mt-5 mr-20 ">
      {isOpen && <Modal modalHandle={modalHandle}>
        <div className="text-left flex flex-col pt-4 px-2">
          <h3 className="text-secondarytwo text-f20 font-semibold">
            Warning!
          </h3>
          <p className="text-secondary pb-4 text-f16 w-[300px]">
            Please note that we accept financial data for the last 5 years only. Since you've uploaded data for the year 2024, any existing data for the years 2019 or earlier will be removed to accommodate the latest information.
          </p>
          <div className="flex text-secondary pt-4 w-full gap-4">
            <Button
              onClick={() => handleSubmit("", true, true)}
              classes="bg-primary px-4 py-2 text-white text-f14 rounded w-full"
            >
              Accept
            </Button>
          </div>
        </div>
      </Modal>}
      <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2 flex">
        Upload Documents (Cash Flow Statement, Income Statement & Balance Sheet)
      </h3>
      <div className={`relative ${!result && "bg-gradient-to-r from-[#FF8D75]/10 to-[#6D1A08]/10 rounded-2 shadow-none p-3 mb-3"}`}>
        <div className={` ${!result && "blur"}`}>
          {<div className={`w-full flex items-center p-2 border-[0.2px] rounded-[8px] text-[10px] gap-2 mb-4 ${error?.message !== '' ? "text-[#FF0000] border-[#FF0000] bg-[#FF0000]/10" : "text-[#0077B5] border-[#0077B5]/20 bg-[#F5FCFF]"}`}>{error?.message !== '' ? <Error height='14px' /> : <Info height='14px' />}<p>{error?.message !== "" ? error?.message : 'You are requesting TREVEX to fill your details manually. Make sure to upload correct document. This may take 2-3 working days.'}</p></div>}
          <div className="border w-full rounded-[8px] p-4 mb-4">
            <form className="flex flex-wrap justify-between">
              {true &&
                years?.map((item, index) => (
                  (isDataLoading && index === currentLoadingIndex) ?
                    <div className="w-[49%] flex justify-center items-center flex-col"><Spinner /><p>Uploading</p></div> :
                    <div className=" w-[49%] text-left mb-5">
                      <div className="text-primary font-semibold mb-2 text-[12px] md:text-[18px] sm:text-[13px]">
                        {item.name}
                      </div>
                      <div
                        className={`border-2 ${previewUrl[index] ? "border" : "border-dashed"
                          }  rounded-lg relative h-48 p-8 ${item?.error ? "border-rose-600 bg-rose-100" : "border-input"} ${isDragging ? "bg-gray-100" : ""
                          }`}
                        onDragOver={(e) => handleDragOver(e, index)}
                        onDragLeave={handleDragLeave}
                        onDrop={(e) => handleDrop(e, index)}
                      >
                        <input
                          type="file"
                          accept=".jpg, .jpeg, .png, .pdf"
                          onChange={(e) => handleFileChange(e, index, item)}
                          ref={(el) => (fileInputRef.current[index] = el)}
                          className="hidden"
                        />
                        {previewUrl[index] != undefined && previewUrl[index] ? (
                          (isDataLoading && index === currentLoadingIndex) ? <div className="flex justify-center items-center flex-col"><Spinner /><p>Uploading</p></div> : <div className="w-full h-36 overflow-hidden border-input rounded-lg border-2 bg-uploadImg">
                            {get_url_extension(previewUrl[index]) == "pdf" ? (
                              <img
                                src={pdf1}
                                alt="Preview PDF"
                                height="40px"
                                className="mx-auto w-3/5"
                                onClick={() => {
                                  viewDoc(previewUrl[index]);
                                }}
                              />
                            ) : (
                              <img
                                src={previewUrl[index]}
                                onClick={() => {
                                  viewDoc(previewUrl[index]);
                                }}
                                alt="Preview IMG"
                                height="40px"
                                className="mx-auto w-3/5"
                              />
                            )}
                          </div>
                        ) : (
                          <div className="text-center">
                            <div>
                              <svg
                                className="w-12 h-12 mx-auto mb-4 text-gray-500"
                                width="49"
                                height="38"
                                viewBox="0 0 49 38"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                onClick={() => handleChooseFile(index)}
                              >
                                <path
                                  d="M40.4927 12.6436C38.2742 3.80599 29.3117 -1.55986 20.4741 0.65858C13.5677 2.3923 8.55291 8.36136 8.03622 15.4632C3.13241 16.2719 -0.187381 20.9027 0.621312 25.8065C1.3402 30.1661 5.11773 33.3588 9.53605 33.3412H17.0352V30.3416H9.53605C6.22273 30.3416 3.53671 27.6555 3.53671 24.3422C3.53671 21.0289 6.22273 18.3429 9.53605 18.3429C10.3644 18.3429 11.0359 17.6714 11.0359 16.843C11.0284 9.388 17.0659 3.33841 24.5209 3.33101C30.9743 3.32454 36.5296 7.88685 37.778 14.2183C37.8381 14.5266 37.9934 14.8083 38.2222 15.0236C38.4509 15.2388 38.7414 15.3769 39.0528 15.4182C43.1532 16.0021 46.0037 19.7994 45.4199 23.8997C44.8956 27.5816 41.752 30.323 38.0329 30.3416H32.0336V33.3412H38.0329C43.8313 33.3237 48.5175 28.609 48.4999 22.8106C48.4853 17.9839 45.1815 13.789 40.4927 12.6436Z"
                                  fill="#5B8098"
                                />
                                <path
                                  d="M23.4696 18.778L17.4702 24.7773L19.585 26.8921L23.0346 23.4575V37.8409H26.0343V23.4575L29.4689 26.8921L31.5837 24.7773L25.5843 18.778C24.9993 18.1964 24.0546 18.1964 23.4696 18.778Z"
                                  fill="#5B8098"
                                />
                              </svg>
                              <p className="md:text-[16px] sm:text-[11px] text-[10px] text-secondarytwo">
                                {isDragging ? "Drop the file here" : "Drag & drop or "}
                                <button
                                  type="button"
                                  onClick={() => handleChooseFile(index)}
                                  className="text-primaryText font-semibold focus:outline-none"
                                >
                                  Choose file
                                </button>
                                to upload
                                <span className="md:text-[14px] text-secondary block text-[10px] sm:text-[10px]">
                                  Supported format : JPG, JPEG, PNG, PDF
                                </span>
                              </p>
                            </div>
                          </div>
                        )}
                        {previewUrl[index] && (
                          <div className="bg-white absolute w-full border-input rounded-b-lg px-8 py-2 border-t-2 bottom-0 left-0 h-16 flex justify-between items-center">
                            <div>
                              <div className="text-secondarytwo sm:text-[10px] md:text-[14px] text-[8px]">
                                {item.update}
                              </div>
                              <div className="text-secondary tracking-wider sm:text-[10px] md:text-[14px] text-[10px] ">
                              </div>
                            </div>
                            <div className="justify-end items-center flex flex-row-reverse ">
                              <MoreInfo
                                className={`cursor-pointer mr-0 ml-auto `}
                                onClick={() => handleOption(index, "more-info")}
                              />

                              {optionDisplay[index] && !isDataLoading && (
                                <ul className="border-2 border-input rounded-lg mt-36 bg-white p-3 w-full z-10">
                                  <li
                                    className="py-1 flex items-center gap-2.5 text-f16 text-secondarytwo cursor-pointer"
                                    onClick={() => {
                                      handleOption(index, "reupload");
                                    }}
                                  >
                                    {" "}
                                    <div>
                                      <ReUploadIcon />
                                    </div>
                                    Re - Upload Document
                                  </li>
                                  {/* <hr className="my-3" />
                                  <li
                                    className="py-1 flex items-center gap-2.5 text-f16 text-decline cursor-pointer"
                                    onClick={() => deleteDocument(index, item)}
                                  >
                                    <DeleteIcon /> Delete
                                  </li> */}
                                </ul>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                ))}
            </form>
          </div>
        </div>
      </div>
      <BackNextButton
        onPrev={handlePrev}
        onNext={handleSubmit}
        onSkip={() => onSkip(0, "MOA", "Upload KK")}
        isLoading={false}
        disable={!result || isDataLoading || imageArray?.length === 0}
      />
    </div>
  );
};